import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const intelApi = {
  inbox: (matterId) => axios.get(`${API}/matters/${matterId}/intel/inbox`).then((r) => r.data),
  causeTitle: (matterId) => axios.get(`${API}/matters/${matterId}/cause-title`).then((r) => r.data),
  causeTitleText: (matterId) => axios.get(`${API}/matters/${matterId}/cause-title/text`).then((r) => r.data),
  applyCauseTitle: (matterId, body) => axios.post(`${API}/matters/${matterId}/cause-title/apply`, body).then((r) => r.data),
  annexureCandidates: (matterId, draftId) => axios.get(`${API}/matters/${matterId}/annexure-candidates`, { params: { draftId } }).then((r) => r.data),
  annexFromDocuments: (draftId, body) => axios.post(`${API}/drafts/${draftId}/annexures/from-documents`, body).then((r) => r.data),
  passport: (matterId) => axios.get(`${API}/matters/${matterId}/passport`).then((r) => r.data),
  propertySchedules: (matterId) => axios.get(`${API}/matters/${matterId}/property-schedules`).then((r) => r.data),
  chainOfTitle: (matterId) => axios.get(`${API}/matters/${matterId}/chain-of-title`).then((r) => r.data),
  requestDocument: (matterId, body) => axios.post(`${API}/matters/${matterId}/intel/request-document`, body).then((r) => r.data),
  confirmSchedule: (documentId, schedule) => axios.put(`${API}/documents/${documentId}/property-schedule`, { schedule }).then((r) => r.data),
  calendar: (from, to) => axios.get(`${API}/calendar/events`, { params: { from, to } }).then((r) => r.data),
  downloadCauseTitle: async (matterId, caseNumber) => {
    const r = await axios.get(`${API}/matters/${matterId}/cause-title/docx`, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = Object.assign(document.createElement("a"), { href: url, download: `Cause_Title_${(caseNumber || matterId).replace(/[^A-Za-z0-9_-]+/g, "_")}.docx` });
    document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  },
};

export const apiError = (e, fallback) => { const d = e?.response?.data?.detail; return typeof d === "string" ? d : d?.message || fallback; };
